module.exports = __webpack_public_path__ + "static/media/notif_darkbleu.7075169b.svg";